import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
const emails = require('../../../services/emails.json');

@Component({
  selector: 'app-call-times',
  templateUrl: './times.component.html',
  styleUrls: ['./times.component.scss']
})
export class VTuberCallTimesComponent implements OnInit {
  @ViewChild('calendar', {static: true}) calendarComponent: FullCalendarComponent;
  calendarPlugins = [dayGridPlugin, interactionPlugin];
  calendarEvents = [];
  defaultDate: string = '';
  selectDate: any = undefined;
  selectTimes: any[];

  constructor(public auth: AuthService, private toastr: ToastrService) {}

  ngOnInit() {
    this.calendarComponent.locales = [ { code: 'ja-JP' } ];
    this.defaultDate = this.auth.futureMonth()
    this.loadEvents();
  }

  columnHeaderText(date) {
    return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
  }

  modifyTitle(eventIndex, newTitle) {
    this.calendarEvents[eventIndex].title = newTitle;
  }

  eventClick(info) {
    this.handleDateClick({
      date: moment(info.event.start).tz('Asia/Tokyo')
    })
  }

  handleDateClick(arg) {
    this.selectDate = arg.date

    let currentData = this.calendarEvents.filter(item => item.date === this.auth.formatDate(this.selectDate))
    this.selectTimes = [];

    if (currentData && currentData.length > 0) {
      currentData.sort((a, b) => {
        if (a.title > b.title) return 1;
        if (a.title < b.title) return -1;
        return 0;
      }).map(item => {
        this.selectTimes.push(Object.assign({
          uid: item.uid,
          hasArrangement: item.hasArrangement
        }, this.auth.parseStringToEventTime(item.title)))
      })
    } else {
      this.selectTimes.push({
        start: { hour: 0, minute: 0},
        end: { hour: 0, minute: 0},
        hasArrangement: false
      })
    }
  }

  addTime() {
    this.selectTimes.push({
      start: { hour: 0, minute: 0 },
      end: { hour: 0, minute: 0 }
    })
  }

  deleteTime(index) {
    if (this.selectTimes[index].uid) {
      this.calendarEvents = this.calendarEvents.filter(item => item.uid !== this.selectTimes[index].uid)

      this.updateEvents()
    }

    this.selectTimes = this.selectTimes.filter((item, ind) => ind !== index)
  }

  getBackgroundColor(item) {
    if (item.hasArrangement === true) return '#e85b46'

    if (item.is_publish && item.is_publish === 1) return '#3788d8'

    return '#999'
  }

  saveTime(index) {
    let event = {
      title: ("00" + this.selectTimes[index].start.hour).slice(-2) + ":" + ("00" + this.selectTimes[index].start.minute).slice(-2) + "~" + ("00" + this.selectTimes[index].end.hour).slice(-2) + ":" + ("00" + this.selectTimes[index].end.minute).slice(-2),
      date: this.auth.formatDate(this.selectDate)
    }

    let uid = Math.random().toString(12).substring(2);

    if (this.selectTimes[index].uid) {
      uid = this.selectTimes[index].uid
      this.calendarEvents = this.calendarEvents.map(item => {
        if (item.uid === uid) {
          return {
            uid: uid,
            hasArrangement: item.hasArrangement ? item.hasArrangement : false,
            is_publish: item.is_publish ? item.is_publish : 0,
            title: event.title,
            date: event.date,
            backgroundColor: this.getBackgroundColor(item),
            borderColor: this.getBackgroundColor(item)
          }
        } else {
          return Object.assign({
            backgroundColor: this.getBackgroundColor(item),
            borderColor: this.getBackgroundColor(item)
          }, item)
        }
      })
    } else {
      this.calendarEvents.push(Object.assign({
        is_publish: 0,
        uid: uid,
        hasArrangement: false,
        backgroundColor: '#999'
      }, event))

      this.selectTimes[index].uid = uid
    }

    this.updateEvents();
  }

  canSave(index) {
    let time = this.selectTimes[index];
    if (time.start && time.end) {
      let diff = (time.end.hour * 60 + time.end.minute) - (time.start.hour * 60 + time.start.minute);
      if (diff > 0 && diff % 5 === 0) return true;
    }

    return false;
  }

  canSend() {
    // return this.calendarEvents.filter(item => item.date.substr(0, 7) === this.defaultDate.substr(0, 7)).length > 0
    return this.calendarEvents.filter(item => item.is_publish === 0).length > 0
  }

  send() {
    this.calendarEvents = this.calendarEvents.map(item => {
      if (item.is_publish === 0) {
        item.is_publish = 1;
        item.backgroundColor = this.getBackgroundColor(item);
        item.borderColor = this.getBackgroundColor(item);
      }
      return item
    });

    this.updateEvents()

    this.auth.sendEmail({
      to: this.auth.user.email,
      subject: emails.call_time_register_subject,
      text: this.auth.getEmailTemplate(emails.call_time_register.join("")).replace(/\[VTuber名\]/g, this.auth.user.displayName)
    })

    this.toastr.success('通話可能時間を送信しました。')
  }

  updateEvents() {
    this.auth.updateUserData({
      uid: this.auth.user.uid,
      events: this.calendarEvents.map(item => {
        return {
          uid: item.uid,
          title: item.title,
          date: item.date,
          hasArrangement: item.hasArrangement,
          is_publish: item.is_publish
        }
      })
    })
    this.auth.fetchUser()
  }

  loadEvents() {
    this.calendarEvents = []
    if (this.auth.user.events) {
      this.calendarEvents = this.auth.user.events.map(item => {
        return Object.assign({
          backgroundColor: this.getBackgroundColor(item),
          borderColor: this.getBackgroundColor(item)
        }, item)
      })
    }
  }
}
